import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { HistoryFormValues } from '../../models/vessels/maritime-ais-api';
import HistoryPanelSampleRate from './history-panel-sample-rate';

dayjs.extend(require('dayjs/plugin/utc'));

type IHistoryPanelState = {
  aisDataGapLength: number;
  refreshData: boolean;
  resultsViewOpen: boolean;
  formValues: HistoryFormValues;
};

export const FORMATTED_TODAY = dayjs().utc().toISOString();

export const FORMATTED_ONE_MONTH_AGO = dayjs()
  .utc()
  .subtract(1, 'month')
  .toISOString();

export const INITIAL_HISTORY_PANEL_STATE: IHistoryPanelState = {
  aisDataGapLength: 24,
  refreshData: false,
  resultsViewOpen: false,
  formValues: {
    identifiers: '',
    startDate: FORMATTED_ONE_MONTH_AGO,
    endDate: FORMATTED_TODAY,
    sampleRate: HistoryPanelSampleRate.ONE_HOUR,
  },
};

const HistoryPanelSlice = createSlice({
  name: 'historyPanel',
  initialState: INITIAL_HISTORY_PANEL_STATE,
  reducers: {
    setAISDataGapLength: (state, action: PayloadAction<number>) => {
      state.aisDataGapLength = action.payload;
    },
    setHistoryFormValues: (
      state,
      action: PayloadAction<Partial<HistoryFormValues> | null>
    ) => {
      // Only updates filters explictly mentioned in action
      state.formValues = {
        ...state.formValues,
        ...action.payload,
      };
    },
  },
});

export const { setHistoryFormValues, setAISDataGapLength } =
  HistoryPanelSlice.actions;

export default HistoryPanelSlice.reducer;
